module.exports = "<div id=\"player\">\n    <video *ngIf=\"url\" id=\"video-player\"\n           class=\"video-js vjs-default-skin vjs-big-play-centered vjs-16-9\"\n           controls preload=\"auto\" crossorigin=\"anonymous\">\n        <source [src]=\"url\" type=\"video/mp4\"/>\n    </video>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// /Users/dominik/Documents/projekty/guru-monarch-beach-resort/guru-monarch-beach-resort/src/app/shared/video-player/video-player.component.html
// module id = ../../../../../src/app/shared/video-player/video-player.component.html
// module chunks = main